import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { useImageNotLoaded } from '@sbt-web/hooks';
import styles from './index.module.scss';
interface Props {
  name: string;
  picture?: string;
}
const UserBadge = t0 => {
  const $ = _c(9);
  const {
    name,
    picture
  } = t0;
  const pictureSrc = picture ? `${picture}?rule=bigthumbs` : "";
  let t1;
  if ($[0] !== name) {
    t1 = name && [...name][0].toUpperCase() || "";
    $[0] = name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const nameInitial = t1;
  const imageNotLoaded = useImageNotLoaded(pictureSrc);
  if (imageNotLoaded || !picture) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = classNames("headline-4", styles.badge, styles["rounded-user-badge"]);
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== nameInitial) {
      t3 = <h4 className={t2}>{nameInitial}</h4>;
      $[3] = nameInitial;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  if (picture) {
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = classNames(styles.badge, styles.picture);
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    let t3;
    if ($[6] !== name || $[7] !== pictureSrc) {
      t3 = <img alt={name} className={t2} src={pictureSrc} />;
      $[6] = name;
      $[7] = pictureSrc;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    return t3;
  }
  return null;
};
export { UserBadge };